module.exports = __webpack_public_path__ + "static/profile_pic-5ab202b0f9fe2781a1a7380274ad6e44.jpg";